import {
  FormattedMessage,
  IntlContextConsumer,
  Link,
} from "gatsby-plugin-react-intl"
import React from "react"
import styled, { css } from "styled-components"

import LanguageSwitcher from "../components/LanguageSwitcher"
import { media } from "../styles"

const NavContainer = styled.div`
  margin: 0 auto;
  padding: 0 15px;
  width: 100%;

  @media ${media.lg} {
    margin: 0 0 0 auto;
    padding: 0;
  }
`

const NavList = styled.ul`
  display: flex;
  flex-flow: column nowrap;
  font-weight: ${({ theme }) => theme.fontWeightBold};
  list-style: none;
  margin: 0 0 0 auto;
  padding: 0;

  @media ${media.lg} {
    flex-flow: row nowrap;
    justify-content: flex-end;
    padding: 0 0 0 10px;
  }

  @media ${media.xl} {
    padding: 0 0 0 20px;
  }
`

const NavItem = styled.li`
  font-size: 27px;
  margin: 0 0 25px;
  line-height: 24px;

  ${(props) =>
    props.mobileOnly &&
    css`
      @media ${media.lg} {
        display: none;
      }
    `}

  @media ${media.tabletLandscape} {
    font-size: 14px;
    margin: 0 0 0 17px;
    white-space: nowrap;

    &:first-child {
      margin-left: 10px;
    }
  }

  @media ${media.desktop} {
    font-size: 16px;
    margin: 0 0 0 30px;

    &:first-child {
      margin-left: 20px;
    }
  }
`

const NavLink = styled(Link)`
  color: ${({ theme }) => theme.brandPrimaryLight};
  transition: color ${({ theme }) => theme.transitionTime};

  &,
  &:hover {
    text-decoration: none;
  }

  &:hover {
    color: ${({ theme }) => theme.brandPrimaryMedium};
  }

  @media ${media.lg} {
    color: ${({ theme }) => theme.textColorLight};

    &:hover {
      color: ${({ theme }) => theme.brandPrimaryDark};
    }

    &.active {
      color: ${({ theme }) => theme.textColor};
    }
  }
`

const ExternalLink = styled.a`
  color: ${({ theme }) => theme.brandPrimaryLight};
  transition: color ${({ theme }) => theme.transitionTime};

  &,
  &:hover {
    text-decoration: none;
  }

  &:hover {
    color: ${({ theme }) => theme.brandPrimaryMedium};
  }

  @media ${media.lg} {
    color: ${({ theme }) => theme.textColorLight};

    &:hover {
      color: ${({ theme }) => theme.brandPrimaryDark};
    }

    &.active {
      color: ${({ theme }) => theme.textColor};
    }
  }
`

const NavigationMain = (props) => {
  return (
    <NavContainer>
      <NavList>
        <NavItem>
          <NavLink to={`/`}>
            <FormattedMessage id="navigationMain.private" />
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink to={`/institutions/`} activeClassName="active">
            <FormattedMessage id="navigationMain.business" />
          </NavLink>
        </NavItem>
        <NavItem>
          <ExternalLink href={`https://support.bsdex.de`}>
            <FormattedMessage id="navigationMain.support" />
          </ExternalLink>
        </NavItem>
        <NavItem>
          <NavLink to={`/fees/`} activeClassName="active">
            <FormattedMessage id="navigationMain.fees" />
          </NavLink>
        </NavItem>
        {props.displayLangSwitcher !== false && (
          <IntlContextConsumer>
            {({ languages }) =>
              languages.length > 1 && (
                <NavItem>
                  <LanguageSwitcher />
                </NavItem>
              )
            }
          </IntlContextConsumer>
        )}
      </NavList>
    </NavContainer>
  )
}

export default NavigationMain
